import api from "@/lib/api";

let cachedPromise = null;
let cachedDate = null;

function today() {
  return new Date().toISOString().slice(0, 10);
}

/**
 * Récupère le plan du jour — une seule requête réseau par jour, peu importe
 * combien de composants le demandent (widget dashboard, page de séance...).
 * Le premier appelant déclenche le GET ; tous les autres, même appelés au
 * même instant, reçoivent la MÊME promesse. Il ne peut donc jamais y avoir
 * deux appels concurrents à /daily-plan/v2/today.
 */
export function fetchDailyPlan(lang = "fr") {
  const d = today();
  if (cachedDate !== d) {
    // Nouveau jour : le cache d'hier n'a plus de sens.
    cachedPromise = null;
    cachedDate = d;
  }
  if (!cachedPromise) {
    cachedPromise = api
      .get(`/daily-plan/v2/today?lang=${lang}`)
      .then((r) => r.data)
      .catch((err) => {
        // Un échec ne doit jamais rester en cache : on autorise un
        // nouvel essai au prochain appel.
        cachedPromise = null;
        throw err;
      });
  }
  return cachedPromise;
}

/** À appeler après un "Refaire la séance" ou la fin d'une séance : force
 * une relecture fraîche du plan/bilan au prochain accès. */
export function invalidateDailyPlan() {
  cachedPromise = null;
  cachedDate = null;
}
